import {
  HttpError,
  NetworkError,
  ValidationError,
} from '@personal-portfolio/api-client';

// Maps a query error to the string|null shape the page views expect.
//
// `isPaused` folds in a state that is not an error but reads as one. TanStack
// stops retrying whenever the window loses focus or the browser goes offline
// (query-core's retryer gates continuation on `focusManager.isFocused() &&
// onlineManager.isOnline()`; networkMode does not exempt it), and a paused
// query keeps status 'pending' indefinitely. With nothing cached to fall back
// on, reporting it as a failure is what stops a page shimmering forever —
// PageState gives `error` precedence over `loading`, so this is the only
// change a page needs.
export const toErrorMessage = (
  error: unknown,
  isPaused = false,
): string | null => {
  if (!error) {
    return isPaused ? 'Cannot reach the server — check your connection' : null;
  }
  if (error instanceof NetworkError)
    return 'Cannot reach the server — check your connection';
  if (error instanceof HttpError)
    return `The server returned an error (HTTP ${error.status})`;
  if (error instanceof ValidationError)
    return 'Received unexpected data from the server';
  if (error instanceof Error) return error.message;
  return 'Something went wrong';
};
